<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-table
                        id="xpane-0"
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        ref="singleTable"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="eval_no" :label="$t('getapi[2095]')"></el-table-column>
                    <el-table-column prop="status" :label="$t('getapi[552]')">
                        <template slot-scope="scope">
                           {{expStatus(scope.row.status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="cus_name" :label="$t('getapi[2584]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="cus_date" :label="$t('getapi[4053]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[8928]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="eval_person" :label="$t('getapi[8931]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="eval_date" :label="$t('getapi[8932]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="eval_content" :label="$t('getapi[8929]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_leader" :label="$t('getapi[6403]')"></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:930px">
                    <el-button type="primary" size="mini" @click="itemConfirm" :disabled="dataDetail.Head.status != 0">{{$t('getapi[6468]')}}</el-button>
                    <el-button type="primary" size="mini" @click="itemDelConfirm">{{$t('getapi[441]')}}</el-button>
                    <el-button type="primary" size="mini" @click="audit" :disabled="!btn.audit">{{$t('getapi[8937]')}}</el-button>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[2095]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.eval_no" type="text"  style="width: 150px"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            
                            <td style="width:60px">{{ $t('getapi[1861]') }}</td>
                             <td style="width:150px;">
                                <el-input :value="expStatus(dataDetail.Head.status)" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px">{{$t('getapi[8000]')}}</td>
                            <td style="width:150px">
                                <el-select filterable v-model="templateid" @change="selectChanged" :disabled="dataDetail.Head.exclusively_id>0" size="mini">
                                    <el-option v-for="item in downdatajson" :key="item.id"
                                               :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </td>
                            <td style="width:60px">{{$t('getapi[2584]')}}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.Head.cus_name" type="text" :readonly="dataDetail.Head.status>0" :class="{'readO':dataDetail.Head.status>0}"  style="width: 150px"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[4053]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.cus_date" type="date" :readonly="dataDetail.Head.status>0" :class="{'readO':dataDetail.Head.status>0}" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[8928]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.part_code" type="text" :readonly="dataDetail.Head.status>0" :class="{'readO':dataDetail.Head.status>0}" style="width: 150px"></el-input>
                            </td>
                            <td>{{$t('getapi[113]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.part_version" type="text" :readonly="dataDetail.Head.status>0" :class="{'readO':dataDetail.Head.status>0}" style="width: 150px"></el-input>
                            </td>
                            <td>{{$t('getapi[6403]')}}</td>
                            <td>
                                <routejump :urlNo="6">
                                <el-input
                                        v-model="dataDetail.Head.item_leader"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItemLeader(1)"></i>
                                </el-input>
                                </routejump>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[8929]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.eval_results" type="text"  :readonly="true" class="readO" style="width: 150px"></el-input>
                            </td>
                            <td>{{$t('getapi[8930]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.eval_content" :readonly="true" class="readO" type="text"  style="width: 150px"></el-input>
                            </td>
                            <td>{{$t('getapi[8931]')}}</td>
                            <td>
                                <routejump :urlNo="6">
                                <el-input
                                        v-model="dataDetail.Head.eval_person"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItemLeader(2)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[8932]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.eval_date" type="date" :readonly="true" class="readO" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
                    <el-tab-pane :label="$t('getapi[2078]')" name="0">
                        <quill-editor
                                ref="text"
                                v-model="dataDetail.Head.description"
                                :height="tableHeight - 120"
                                class="myQuillEditor"
                                :options="quillOption"/>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[8939]')" name="1">
                        <vxe-table
                                :data="dataDetail.List"
                                :highlight-current-row="true"
                                style="width: 100%; margin-top:3px"
                                resizable
                                show-overflow="tooltip"
                                :height="tableHeight - 160"
                                header-row-class-name="headerclass"
                                :row-class-name="tableRowClassName1"
                                size="mini"
                                border
                                ref="singleTable1"
                        >
                            <vxe-table-column type="checkbox" align="center" field="isenable"  width="40" v-if="false"></vxe-table-column>
                            <vxe-table-column field="isenable" :title="$t('getapi[6158]')"  width="75">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.isenable" :disabled="dataDetail.Head.status>0" :true-label=1 :false-label=0>
                                    </el-checkbox>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="itemstage" :title="$t('getapi[7944]')"  width="120"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="item_strategyno" :title="$t('getapi[1297]')"  width="50"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="content" :title="$t('getapi[6160]')"  width="150"></vxe-table-column>
                            <!-- <vxe-table-column show-footer-overflow field="blamedept" :title="$t('getapi[8001]')"  width="100"></vxe-table-column> -->
                            <vxe-table-column show-footer-overflow field="blamepeople" :title="$t('getapi[7946]')"  width="100"></vxe-table-column>
                            <vxe-table-column field="plan_person" :title="$t('getapi[6161]')"  width="150">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.plan_person"
                                            type="text"
                                            readonly
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectPlanPerson(scope)"></i>
                                    </el-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="plan_time" :title="$t('getapi[6162]')"  width="140">
                                <template slot-scope="scope">
                                    <el-date-picker
                                            v-model="scope.row.plan_time"
                                            type="date"
                                            value-format="yyyy/MM/dd"
                                            @blur="checkfclick(scope)"
                                            size="mini"
                                            style="width:100%"
                                    ></el-date-picker>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="complete_time" :title="$t('getapi[6163]')"  width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="eval_content" :title="$t('getapi[8934]')"  width="150">
                            </vxe-table-column>
                            <vxe-table-column field="eval_status" :title="$t('getapi[8933]')"  width="200">
                                <template slot-scope="scope"  >
                                    <el-radio-group v-model="scope.row.eval_status" @input="appr(scope.row)" >
                                        <template v-if="scope.row.isenable==1">
                                            <el-radio :label="1" :disabled="scope.row.eval_status!=0">{{$t('getapi[8935]')}}</el-radio>
                                            <el-radio :label="2" :disabled="scope.row.eval_status!=0">{{$t('getapi[8936]')}}</el-radio>
                                        </template>
                                    </el-radio-group>
                                </template>
                            </vxe-table-column>
                            
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6421]')">
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                action=""
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChange"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :http-request="uploadFile"
                                :auto-upload="true"
                        >
                            <el-button type="primary" size="mini">{{$t('getapi[6941]')}}
                            </el-button>
                        </el-upload>
                        <el-table
                                :data="dataDetail.FileList"
                                v-loading="loading"
                                :highlight-current-row="false"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                header-row-class-name="headerclass"
                        >
                            <el-table-column show-overflow-tooltip prop="filename"
                                             :label="$t('getapi[3590]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="doc_type"
                                             :label="$t('getapi[6423]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="doc_size"
                                             :label="$t('getapi[7875]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="upload_person"
                                             :label="$t('getapi[6425]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="upload_time"
                                             :label="$t('getapi[6426]')"></el-table-column>
                            <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="open(scope)" type="text" size="mini">{{
                                        $t('getapi[3611]') }}
                                    </el-button>
                                    <el-button @click.native.prevent="filedel(scope)" type="text" size="mini">{{
                                        $t('getapi[40]') }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="NewProEvalManageInfo" ref="ser" @getser="serclick"></serce>
        <!--实施计划负责人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getPlanPerson" ref="planperson"></selector>
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getItemLeader" ref="itemleader"></selector>

        <el-dialog v-dialogDrag center :title="$t('getapi[6404]')" :visible.sync="auditVisible" width="30%">
            <table>
                <tr>
                    <td>{{$t('getapi[2095]')}}</td>
                    <td>
                        {{auditdata.eval_no}}
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[8931]')}}</td>
                    <td>
                        {{auditdata.eval_person}}
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[8933]')}}</td>
                    <td>
                        <el-radio-group v-model="auditdata.eval_results">
                            <el-radio label="OK">OK</el-radio>
                            <el-radio label="NG">NG</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[8934]')}}</td>
                </tr>
            </table>
            <el-input v-model="auditdata.eval_content" type="textarea" :rows="5" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="auditVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmAudit">{{$t('getapi[2051]')}}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag center :title="$t('getapi[6404]')" :visible.sync="dialogVisible" width="30%">
            <table>
                <tr>
                    <td>{{$t('getapi[8933]')}}</td>
                    <td>
                        {{expEvalStatus(apprdata.eval_status)}}
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[8934]')}}</td>
                </tr>
            </table>
            <el-input v-model="apprdata.eval_content" type="textarea" :rows="5" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmAppr">{{$t('getapi[2051]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import Quill from 'quill';
    import {quillEditor} from 'vue-quill-editor';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import {container, ImageExtend} from 'quill-image-extend-module';
    import {Loading} from 'element-ui';
    Quill.register('modules/ImageExtend', ImageExtend);
    import quillConfig from '@/utils/config.js';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        components: {
            quillEditor
        },
        name: 'newproeval',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                quillOption: quillConfig,
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('newproeval'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    Head: {},
                    List: [],
                    FileList: [],
                }, // 编辑页面数据详情
                oldDataDetail: '',
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                addoredit: 1,
                code: '', // 单据唯一号
                rowindex: '',
                uploadurl: '',
                fileList: [],
                file: null,
                downdatajson:[],
                templateid:0,
                isVisiblefile: false,
                filecode: '', // 项目清单code
                selectData:[],
                auditVisible: false,
                auditdata:{
                    exclusively_id: '',
                    eval_no:'',
                    eval_results:'',
                    eval_content:'',
                    eval_person:'',
                },
                dialogVisible: false,
                apprdata:{
                    main_exclusively_id:'',
                    modify_time:'',
                    exclusively_id:'',
                    relation_evalno:'',
                    eval_status: '',
                    eval_content:'',
                },
                persontype:1,//1:项目负责人2：综合判定人
                btn: {
                    audit: false,
                    canupload: false
                },
                scrollTop:0,
                scrollTop1:0,
            };
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('newproeval', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            let token = JSON.parse(that.userData).token;
            that.fileurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.downdata();
            that.authority()
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })

        },
        methods: {
            // 获取数据
            downdata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                that.$http.urlpost('/Eng/NewProEval/GetSTempDownList', {}, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.downdatajson = res.DataContent;
                        that.templateid=that.downdatajson[0].id;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8924]"),this.$t("getapi[18]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.$limits.authority('plv2', 560, 1) == 1) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 560, 1) == 2) {
                    if (that.$limits.authority('plv3', 560,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 560, 1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 560, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.eval_no)){
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.audit = false
                if(that.dataDetail.Head.status == 1 || that.dataDetail.Head.status == 2 || that.dataDetail.Head.status == 3){
                    if(that.$limits.fnIsEmpty(that.dataDetail.Head.eval_results)){
                        if(that.dataDetail.Head.eval_person.indexOf(that.user) != -1){
                            that.btn.audit = true
                        }
                    }
                }
            },
             tableRowClassName1({row, rowIndex}) {
                row.index = rowIndex;
                if (row.ismust == 1 && row.exclusively_id<=0) {
                    return 'yellow';
                }
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if (!that.iscontinuedblclick) {
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('newproeval',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'NewProEvalManageInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Eng/NewProEval/NewProEvalView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndexs)
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if (that.code == row.eval_no) {
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.List.length;i++){
                        delete datacopy.List[i]['index'];
                        delete datacopy.List[i]['_XID'];
                    }
                    if (that.oldDataDetail != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.eval_no;
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.eval_no;
                        that.getDetail(that.code);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.dloading = true;
                that.addoredit = 2;
                that.selectData = [];
                that.dataChecked = [];
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Eng/NewProEval/GetNewProEvalInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        // console.log("测试数据:"+JSON.stringify(that.dataDetail))
                        that.templateid=that.dataDetail.List[0].itemstemid;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority();
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['index'];
                    delete datacopy.List[i]['_XID'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        exclusively_id:'',
                        eval_no:'',
                        status:0,
                        status_name:'',
                        description:'',
                        create_person:'',
                        create_time:'',
                        modify_person:'',
                        modify_time:'',
                        confirm_person:'',
                        confirm_time:'',
                        item_notes:'',
                        cus_name:'',
                        cus_date:'',
                        part_code:'',
                        part_version:'',
                        item_leader:'',
                        eval_results:'',
                        eval_content:'',
                        eval_person:'',
                        eval_date:''
                    },
                    List: [],
                    FileList: [],
                };
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.getItemInfo()
                that.authority();
            },
            audit(){
                let that = this
                that.auditVisible = true
                that.auditdata = {
                    exclusively_id: that.dataDetail.Head.exclusively_id,
                    eval_no: that.dataDetail.Head.eval_no,
                    modify_time: that.dataDetail.Head.modify_time,
                    eval_results: that.dataDetail.Head.eval_results,
                    eval_content: '',
                    eval_person: that.dataDetail.Head.eval_person
                }
            },
            confirmAudit(){
                let that = this
                let parm = that.auditdata
                that.$http.urlpost('/Eng/NewProEval/AuditNewProEval', parm, function (res) {
                    if (res.Success == 1) {
                        that.auditVisible = false
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            appr(val){
                let that = this;
                that.dialogVisible = true
                that.apprdata.main_exclusively_id = that.dataDetail.Head.exclusively_id
                that.apprdata.modify_time = that.dataDetail.Head.modify_time
                that.apprdata.exclusively_id = val.exclusively_id
                that.apprdata.relation_evalno = val.relation_evalno
                that.apprdata.eval_status = val.eval_status
                that.apprdata.eval_content = ''
            },
            confirmAppr(){
                let that = this
                let parm = that.apprdata
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Eng/NewProEval/ApprNewProEval', parm, function (res) {
                    if (res.Success == 1) {
                        that.dialogVisible = false
                        that.getDetail(that.code)
                    }
                });
            },
            selectChanged(){
                this.getItemInfo();
            },
            getItemInfo(){
                let that = this
                let parm = {
                    Id:that.templateid
                };
                that.$http.urlpost('/Eng/NewProEval/GetAddNewProEvalInfo', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.dataDetail.List = res.DataContent.StrategyList
                            that.oldDataDetail = JSON.stringify(that.dataDetail)
                        }
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['index'];
                    delete datacopy.List[i]['_XID'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if (that.addoredit != 1) {
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if (that.addoredit != 1) {
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[8924]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Eng/NewProEval/NewProEvalViewToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Eng/NewProEval/SaveNewProEvalManager', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = res.UniqueNum;
                        that.code = parm;
                        that.getDetail(parm);
                    }
                });
            },
            // 删除
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            "exclusively_id": that.dataDetail.Head.exclusively_id,
                            "eval_no": that.dataDetail.Head.eval_no,
                            "status": that.dataDetail.Head.status,
                            "modify_time": that.dataDetail.Head.modify_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Eng/NewProEval/DeleteNewProEval', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this
                that.file = file.raw
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(res.Msg);
                } else {
                    console.log('导入成功')
                    that.authority()
                    that.getView()
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            uploadFile() {
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('Code', that.dataDetail.Head.eval_no)
                that.$http.urlpost('/Eng/NewProEval/NewProEvalUpLoadFile', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            filedel(val){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: val.row.exclusively_id,
                            FilesSrc: val.row.path
                        }
                        that.$http.urlpost('/Eng/NewProEval/DelItemFileByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            open(val){
                let that = this
                window.open(val.row.path);
            },
            // 确认
            itemConfirm(){
                let that = this
                let parm = {
                    exclusively_id: that.dataDetail.Head.exclusively_id,
                    eval_no: that.dataDetail.Head.eval_no,
                    modify_time: that.dataDetail.Head.modify_time,
                    status: that.dataDetail.Head.status,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Eng/NewProEval/NewProEvalConfirm', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            // 确认
            itemDelConfirm(){
                let that = this
                let parm = {
                    exclusively_id: that.dataDetail.Head.exclusively_id,
                    eval_no: that.dataDetail.Head.eval_no,
                    modify_time: that.dataDetail.Head.modify_time,
                    eval_results: that.dataDetail.Head.eval_results,
                    eval_content: that.dataDetail.Head.eval_content,
                    eval_person: that.dataDetail.Head.eval_person
                }
                that.$http.urlpost('/Eng/NewProEval/CloseNewProEval', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            //
            selectPlanPerson(row){
                let that = this
                that.rowindex = row.$rowIndex;
                that.$refs.planperson.clearInput(true);
            },
            getPlanPerson(val){
                let that = this
                that.dataDetail.List[that.rowindex].plan_person = val.name + '(' + val.code + ')'
            },
            selectItemLeader(val){
                let that = this
                that.persontype = val
                that.$refs.itemleader.clearInput(true);
            },
            getItemLeader(val){
                let that = this
                if(that.persontype == 1){
                    that.dataDetail.Head.item_leader = val.name + '(' + val.code + ')'
                } else {
                    that.dataDetail.Head.eval_person = val.name+ '(' + val.code + ')'
                }
            },
            checkfclick(val) {
                let that = this
                that.rowindex = val.$rowIndex;
                that.dataDetail.List[that.rowindex].isenable = 1;
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[2051]')//'确认';
                } else if (val == 2) {
                    return that.$t('getapi[8925]')//'评估中';
                } else if (val == 3) {
                    return that.$t('getapi[8926]')//'评估完毕';
                } else if (val == 4) {
                    return that.$t('getapi[441]')//'关闭';
                } else {
                    return '';
                }
            },
            expEvalStatus(val) {
                let that = this
                if (val == 1) {
                    return that.$t('getapi[8935]')//'满足';
                } else if (val == 2) {
                    return that.$t('getapi[8936]')//'不满足';
                } else {
                    return '';
                }
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 560,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['index'];
                    delete datacopy.List[i]['_XID'];
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },

        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    .quill-editor.myQuillEditor {
        height: 600px;
        overflow-y: auto;
    }
    /deep/.yellow{
        background: #EE7700;
    }
</style>
